export const colors = {
  normal: '#d00000',
  selected: '#f07b5d',
};

export const basicModals = [
  'about',
  'account',
  'buy-credits',
  'download-map',
  'drawing-properties',
  'embed',
  'export-map',
  'export-map-features',
  'gallery-filter',
  'gallery-upload',
  'legend',
  'login',
  'map-settings',
  'maps',
  'premium',
  'support-us',
  'tracking-my',
  'tracking-watched',
  'upload-track',
] as const;

export const tools = [
  'changesets',
  'draw-lines',
  'draw-points',
  'draw-polygons',
  'map-details',
  'objects',
  'route-planner',
  'track-viewer',
] as const;
